var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('h4',{staticClass:"headline"},[_vm._v(" "+_vm._s(_vm.$t('logoutPage.loading'))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }